import React, { createContext, useReducer } from 'react';
import { AppInitialState, globalReducer } from './reducers';

export const AppContext = createContext(null);

export const ContextProvider = (prop) => {
  const [state, dispatcher] = useReducer(
    globalReducer,
    AppInitialState,
    undefined
  );

  return (
    <AppContext.Provider value={{ state, dispatcher }}>
      {prop.children}
    </AppContext.Provider>
  );
};
